import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
const CustomDialog = ({
    open,
    handleClose,
    title,
    message,
    cancelText,
    confirmText,
    onClick,
    children,
    disabled,
    noConfirm = true,
}) => {

    const handleClick = () => {
        onClick();
        handleClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {message}
                </DialogContentText>
                {children}
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="error"
                    style={{ color: "white" }}
                    onClick={handleClose}
                >
                    {cancelText ? cancelText : "Annuler"}
                </Button>
                {noConfirm && (
                    <Button
                        variant="contained"
                        color="success"
                        style={{ color: "white" }}
                        onClick={handleClick}
                        autoFocus
                        disabled={disabled}
                    >
                        {confirmText ? confirmText : "Confirmer"}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};
export default CustomDialog;
